import React, { Component, PropTypes } from 'react';
import { Icon, Table, Spin } from 'antd';
import { Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';

import { formatNumber } from 'utils/formatting';

import { connect } from 'react-redux';
// import { getPointList } from 'redux/modules/order';
import { TableHelper } from 'helpers/Table';
import classes from '../styles/student/StudentInfo.module.scss';
// import { getPointList, getPageList, postNewPageContent } from 'redux/modules/content'

class StudentPoint extends Component {
  constructor() {
    super();
    // this.onChangePage = this.onChangePage.bind(this);
    this.state = {
      page: 1,
      display: 'earned', // earned, spent
    };
  }

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  onReload = () => {
    this.props.reloadData();
    // this.props.getPointList(this.props.user._id, this.getCurrentQuery()).then(_.noop);
  };

  // onChangePage(page) {
  //   this.props.getPointList(this.props.user._id, _.merge(this.getCurrentQuery(), { page }));
  //   this.setState({
  //     page: page,
  //   });
  // }

  onTableChange = (a, b, sorter) => {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onReload);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onReload);
    }
  };

  getCurrentQuery() {
    return {
      page: this.state.page,
      sortBy: this.state.sortBy,
    };
  }

  columns = [
    {
      ...TableHelper.datetimeColumn('Earn\nDate', 'createdAt'),
    },
    {
      ...TableHelper.datetimeColumn('Expired date', 'expired'),
    },
    {
      ...TableHelper.defaultColumn('Order Code', 'order.code'),
      render: (value, record) => (
        <div className="no-wrap">
          {record.order ? (
            <div>
              {' '}
              <Link to={`/order-item/${_.get(record, 'order._id')}`}>{value} </Link>
              {_.get(record, 'order.remark') && <Icon type="pushpin" />}
            </div>
          ) : (
            <div />
          )}
        </div>
      ),
    },
    {
      ...TableHelper.defaultColumn('Class / Remark', 'order.class.name'),
      render: (value, record) => {
        if (!record.order) {
          return <div>Remark: {record.remark}</div>;
        }
        return <Link to={`/class/${record.order.class._id}`}>{value}</Link>;
      },
      width: '500px',
    },
    {
      ...TableHelper.defaultColumn('Class No.', 'order.class.classCode'),
      render: (value, record) => {
        if (!record.order) {
          return <div />;
        }
        return <Link to={`/class/${record.order.class._id}`}>{value}</Link>;
      },
    },
    {
      ...TableHelper.integerColumn('T-Points', 'points'),
    },
  ];

  spentPointsColumns = [
    {
      ...TableHelper.datetimeColumn('Use\nDate', 'createdAt'),
    },
    {
      ...TableHelper.defaultColumn('RefNo', 'refNo'),
      render: (value, record) => (
        <div className="no-wrap">
          <Link to={`/order/${record._id}`}>{value} </Link>
          {_.get(record, 'remark') && <Icon type="pushpin" />}
        </div>
      ),
    },
    // {
    //   ...TableHelper.defaultColumn('Order Code', 'class.name'),
    //   render: (value, record) => {
    //   <Link to={`/class/${record.class._id}`}>{value}</Link>
    //   },
    //   width: '500px',
    // },
    // {
    //   ...TableHelper.defaultColumn('Class No.', 'class.classCode'),
    //   render: (value, record) => <Link to={`/class/${record.class._id}`}>{value}</Link>,
    // },
    {
      ...TableHelper.integerColumn('T-Points', 'points'),
      render: (value) => <span className={'red'}>-{formatNumber(value, '0,0')}</span>,
    },
  ];

  renderContentTable() {
    const content = this.props.points.results.map((singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    return (
      <div>
        <Table columns={this.columns} dataSource={content} bordered pagination={false} onRowClick={() => {}} onChange={this.onTableChange} />
      </div>
    );
  }

  renderSpentTable() {
    const content = this.props.spentPoints.results.map((singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    return (
      <div>
        <Table columns={this.spentPointsColumns} dataSource={content} bordered pagination={false} onRowClick={() => {}} onChange={this.onTableChange} />
      </div>
    );
  }

  render() {
    const { ordersLoading, approveOrderLoading } = this.props;
    if (!this.props.points) {
      return <div></div>;
    }
    return (
      <div className="content">
        <div className={classes.displayContainer}>
          <span className={cn({ [classes.active]: this.state.display === 'earned' }, 'pointer')} onClick={() => this.setState({ display: 'earned' })}>
            Earned Points
          </span>{' '}
          |{' '}
          <span className={cn({ [classes.active]: this.state.display === 'spent' }, 'pointer')} onClick={() => this.setState({ display: 'spent' })}>
            Used Points
          </span>
        </div>
        <Spin tip="Loading" size="large" spinning={!!ordersLoading || !!approveOrderLoading}>
          {this.state.display === 'earned' && this.renderContentTable()}
          {this.state.display === 'spent' && this.renderSpentTable()}
        </Spin>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    // page: state.order.userOrderList.page,
    // approveOrderLoading: state.order.approveOrderWaiting,
  }),
  {
    // openModal,
    // verify,
    // approveOrder,
  },
)(StudentPoint);
